import React from 'react';
import PropTypes from 'prop-types';
import Instafeed from 'instafeed.js';
import Collapsible from 'react-collapsible';
import { Slider, Pagination } from 'react-slick';
import { toggleInfoPanel } from '../../../actions/uiPreferences';
import './styles.scss';

const propTypes = {
  type: PropTypes.string,
  numImages: PropTypes.number,
  arrows: PropTypes.string,
};

const defaultProps = {
  limit: '',
  numImages: 6,
  arrows: '#ig-btn',
  feed: []
};

class InstagramCarousel extends React.Component {

  componentDidMount() {
    let { numImages } = this.props;
    let feed = new Instafeed({
      get: 'user',
      userId: '37697752',
      sortBy: 'most-recent',
      limit: 20,
      accessToken: '37697752.1677ed0.df5dbceed02f42e4bcb2ed4f9cee5251',
      clientId: '3e8daa9f6f9a49ae83216bd7a11646bc',
      template: '<a href="{{link}}" target="_blank"><img class="img-fluid instagram-feed-'+ numImages +'" src="{{image}}"/></a>',
      resolution: (numImages > 4) ? 'thumbnail' : (numImages === 2) ? 'standard_resolution' : 'low_resolution',
      after: function() {
        let feedCarousel = $('#instafeed');
        let anchors = $("#instafeed > a");

        for (let i = 0; i < anchors.length; i += numImages) {
          anchors.slice(i, i+numImages).wrapAll("<div class='instagram-slide'></div>");
        }

        if (!feedCarousel.hasClass('slick-initialized')) {
          $('#instafeed').slick({
            nextArrow: $('[data-carousel-controls="instagram-carousel"]').find('.ig-btn.next'),
            prevArrow: $('[data-carousel-controls="instagram-carousel"]').find('.ig-btn.previous'),
            infinite: true
          });
        } else {
          $('.instagram-slide').each(function(i, slide){
            if (!$(slide).hasClass('slick-slide')) {
              feedCarousel.slick('addSlide', slide);
            }
          });
        }
      }
    });

    if ($('#instafeed').length) {
      feed.run();
      $('#instafeed').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if (event.type === 'beforeChange' && nextSlide === slick.$slides.length - 1) {
            feed.next();
        }
      });
    }

  }

  componentWillUnmount() {
    if ($('#instafeed').hasClass('slick-initialized')) {
      $('#instafeed').slick('unslick');
      $('#instafeed').empty();
    }
  }

  paginationRender(currentPage, totalPages) {
    const { relatedSnapshots, slickSettings, currentItem } = this.props;
    let feeds = (_.isEmpty(relatedSnapshots)) ? _.get(currentItem,'cam_group.feeds', []) : relatedSnapshots;

    var isHidden = (feeds.length <= slickSettings.slidesToShow) ? ' is-hidden ' : ' ';

    return (
      <div className={"carousel-controller crsl-nav d-flex justify-content-between align-items-center" + isHidden} id="video-carousel-nav">
        <button className="left pagination-btn previous" onClick={this.previous}><i className="icon-ButtonArrowLeft"></i></button>
        <div ref="slideNumber" className="video-carousel-paging"><span className="pr-10">{currentPage}</span>/<span className="pl-10">{totalPages}</span> </div>
        <button className="right pagination-btn next" onClick={this.next}><i className="icon-ButtonArrowRight"></i></button>
      </div>
    );
  }

  render() {

    const { feed } = this.props;

    return (
      <div>
        <div id="instafeed" data-carousel="instagram-carousel">
          { feed.map( item => item ) }
        </div>
        <div data-carousel-controls="instagram-carousel">
          <ul className="carousel-buttons pb-10">
            <li className="carousel-controls-wrapper">
              <button id="ig-btn" className="ig-btn video-player-btn left float-left previous"><i className="icon-ButtonArrowLeft"></i></button>
              <button id="ig-btn" className="ig-btn video-player-btn right float-left next"><i className="icon-ButtonArrowRight"></i></button>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

InstagramCarousel.propTypes = propTypes;
InstagramCarousel.defaultProps = defaultProps;

export default InstagramCarousel;
